import { BarChart3, ExternalLink, Search } from 'lucide-react'

import { SidebarNavGroup, SidebarSwitchRow, useProductShell } from '@/components/sidebar'
import type { SidebarTab } from '@/lib/sidebarTab'
import { CollapsibleNavMenu } from './CollapsibleNavMenu'
import {
  ADMIN_ITEMS,
  CONSOLE_ITEMS,
  EXTERNAL_ITEMS,
  LOOKUP_ITEMS,
  PRODUCTS_SWITCH,
  REPORTING_ITEMS,
  SALES_ITEMS,
} from './navigation'

interface ConsoleNavProps {
  pathname: string
  onSwitch: (tab: SidebarTab) => void
}

export function ConsoleNav({ pathname, onSwitch }: ConsoleNavProps) {
  const shell = useProductShell()
  return (
    <>
      {/* The way out sits at the top: the console list is too long to hide an exit under. In the shared
          shell the bar's Insurance tab is the way out. */}
      {!shell && (
        <SidebarNavGroup>
          <SidebarSwitchRow
            title={PRODUCTS_SWITCH.title}
            icon={PRODUCTS_SWITCH.icon}
            onClick={() => onSwitch(PRODUCTS_SWITCH.tab)}
          />
        </SidebarNavGroup>
      )}

      <SidebarNavGroup links={CONSOLE_ITEMS} separator={!shell} />

      <SidebarNavGroup links={SALES_ITEMS} separator>
        <CollapsibleNavMenu label="Lookups" icon={Search} items={LOOKUP_ITEMS} pathname={pathname} />
        <CollapsibleNavMenu label="Reporting" icon={BarChart3} items={REPORTING_ITEMS} pathname={pathname} />
      </SidebarNavGroup>

      <SidebarNavGroup links={ADMIN_ITEMS} separator>
        <CollapsibleNavMenu
          label="External Links"
          icon={ExternalLink}
          items={EXTERNAL_ITEMS}
          pathname={pathname}
          external
        />
      </SidebarNavGroup>
    </>
  )
}
